import React from 'react'

import { inject, observer } from 'mobx-react'

import DrillDownFilter from '~/client/src/shared/components/DrillDownFilter'
import { ListHeader } from '~/client/src/shared/components/ListHeader'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import CompaniesStore from '~/client/src/shared/stores/domain/Companies.store'
import LocationAttributesStore from '~/client/src/shared/stores/domain/LocationAttributes.store'
import ProjectMembersStore from '~/client/src/shared/stores/domain/ProjectMembers.store'
import ProjectsStore from '~/client/src/shared/stores/domain/Projects.store'
import TagsStore from '~/client/src/shared/stores/domain/Tags.store'
import WorkflowCategoriesStore from '~/client/src/shared/stores/domain/WorkflowCategories.store'
import WorkflowTypesStore from '~/client/src/shared/stores/domain/WorkflowTypes.store'

import { useWorkflowFilterCategories } from './useWorkflowFilterCategories'

interface IProps {
  tagsStore?: TagsStore
  workflowTypesStore?: WorkflowTypesStore
  companiesStore?: CompaniesStore
  projectMembersStore?: ProjectMembersStore
  locationAttributesStore?: LocationAttributesStore
  workflowCategoriesStore?: WorkflowCategoriesStore
  projectsStore?: ProjectsStore
  availableProjectIds?: string[]
  onApplyFilters?: (tagIds: string[]) => void
  initialSelectedTagIds?: string[]
}

const WorkflowFilters: React.FC<IProps> = ({
  tagsStore,
  workflowTypesStore,
  companiesStore,
  projectMembersStore,
  locationAttributesStore,
  workflowCategoriesStore,
  projectsStore,
  availableProjectIds,
  onApplyFilters,
  initialSelectedTagIds,
}) => {
  // Use shared hook for filter categories with proper styling
  const categories = useWorkflowFilterCategories({
    tagsStore,
    permitTypesStore: workflowTypesStore,
    companiesStore,
    projectMembersStore,
    locationAttributesStore,
    formCategoriesStore: workflowCategoriesStore,
    projectsStore,
    availableProjectIds,
  })

  const handleApply = React.useCallback(
    (selectedIds: string[]) => {
      onApplyFilters?.(selectedIds)
    },
    [onApplyFilters],
  )

  const totalSelectedCount = initialSelectedTagIds?.length ?? 0

  return (
    <ListHeader.Filter badgeCount={totalSelectedCount}>
      <DrillDownFilter.Platform
        title={Localization.translator.filterBy}
        categories={categories}
        initialSelection={initialSelectedTagIds}
        onApply={handleApply}
      />
    </ListHeader.Filter>
  )
}

export default inject(
  'tagsStore',
  'workflowTypesStore',
  'companiesStore',
  'projectMembersStore',
  'locationAttributesStore',
  'workflowCategoriesStore',
  'projectsStore',
)(observer(WorkflowFilters))
